import type { IntlShape } from 'react-intl';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import uuid from 'uuid';

import { defaultParameters } from '../defaults';
import type { ParseNumber } from '../types';
import type { ChartTypes, Orientation, UserLegendPosition } from '../ui/charts/types';

export const buildChartADF = ({
	adf,
	intl,
	parseNumber,
	sourceId,
}: {
	adf: any;
	intl: IntlShape;
	parseNumber: ParseNumber;
	sourceId: string;
}): {
	attrs: {
		extensionKey: string;
		extensionType: string;
		// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
		localId: any;
		parameters: {
			chartGroup: {
				customizeTab: {
					legendField: {
						legendPosition: UserLegendPosition.AUTO;
						showLegend: boolean;
					};
					styleField: {
						height: number;
						orientation: Orientation;
						showPoints: boolean;
						smooth: boolean;
					};
					titlesField: {
						chartTitle: string;
						xLabel: string;
						yLabel: string;
					};
				};
				dataTab: {
					aggregateData: boolean;
					xAxisIdxField: string;
					yAxisIdxField: string[];
				};
			};
			chartType: ChartTypes;
			extensionTitle: string;
		};
	};
	marks: {
		attrs: {
			sources: string[];
		};
		type: string;
	}[];
	type: string;
} => {
	return {
		type: 'extension',
		attrs: {
			extensionType: 'com.atlassian.chart',
			extensionKey: 'chart:default',
			parameters: defaultParameters(adf, intl, parseNumber),
			// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
			localId: uuid(),
		},
		marks: [
			{
				type: 'dataConsumer',
				attrs: {
					sources: [sourceId],
				},
			},
		],
	};
};
